<template>
  <ActionSheet
    :close-click-outside="closeClickOutside"
    v-on="$attrs"
  >
    <ArchiveTopPeriods
      :items="items"
      :title="title"
      @close="closeActionSheet"
    />
  </ActionSheet>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ArchiveTopPeriods from './ArchiveTopPeriods.vue';
  import ActionSheet from '~/components/ActionSheet.vue';

  interface ISwitchItem {
    id?: string;
    title?: string;
    isActive: boolean;
    link: HTMLAnchorElement;
  }

  export default defineNuxtComponent({
    name: 'ArchiveTopPeriodsMobile',

    components: {
      ArchiveTopPeriods,
      ActionSheet,
    },

    props: {
      title: {
        type: String as PropType<string>,
        required: true,
      },

      closeClickOutside: {
        type: Boolean as PropType<boolean>,
        default: true,
      },

      items: {
        type: Array as PropType<Array<ISwitchItem>>,
        required: true,
      },
    },

    emits: ['close'],

    methods: {
      closeActionSheet() {
        this.$emit('close');
      },
    },
  });
</script>

<style lang="scss" scoped>
  .list {
    $list: &;

    display: flex;
    flex-wrap: nowrap;

    &__item {
      font-family: $headline-font--1;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $icon-color--1;
      padding: 12px 16px;
      border: 1px solid transparent;

      &:hover {
        &:not([class$='--current']) {
          color: $mainBlack;
        }
      }

      &--current {
        border-color: $actionUiColor;
        color: $actionUiColor;
        cursor: default;
        border-radius: 50%;
      }
    }
  }
</style>
